<template>
    <div class="container">
      <div class="row mb-1">
          <div class="col-sm text-start pb-1">
              <span class="badge rounded-pill pull-left text-light mt-1 py-2 px-4 me-5" style="font-size:18px; background:Tan">
                  <b>Report Summary Testsuits   : สรุปรายการสั่งชุดตรวจ</b>
              </span>
              <div class="badge rounded-pill border pull-left mt-1 pt-0 pb-0 px-4 me-5 text-dark" style="font-size:14px;background:AntiqueWhite">
                  <div class="form-check form-check-inline mx-3" title="แสดงรายการสถานะใหม่">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="status0New">
                  <label class="form-check-label mt-1" for="inlineCheckbox1"><b>New</b> </label>
                  </div>
                  <div class="form-check form-check-inline mx-2 " title="แสดงรายการที่รับเข้าห้องแล็บแล้ว">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox2" v-model="status1Lab">
                  <label class="form-check-label mt-1" for="inlineCheckbox2"><b>Lab</b> </label>
                  </div>
                  <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่ป้อนผลแล้วรออนุมัติ">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox3" v-model="status2Res">
                  <label class="form-check-label mt-1" for="inlineCheckbox3"><b>Resulted</b> </label>
                  </div>
                  <div class="form-check form-check-inline mx-2 " title="แสดงรายการที่ป้อนผลและอนุมัติแล้ว">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox4" v-model="status3App">
                  <label class="form-check-label mt-1" for="inlineCheckbox4"><b>AP</b> </label>
                  </div>
              </div>
          </div>
      </div>
      <div class="row">
          <div class="col-sm">
              <div class="row">
                  <div class="col-sm-4">
                    <!-- สาขาแล็บ -->
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" style="width:120px;">สาขา* :</span>
                        <!-- <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="branchID" >
                            <option disabled value="">Please select one</option>
                            <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                        </select> -->
                        <select v-model="branchSelected" class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID">
                            <option disabled value="">Please select one</option>
                            <option v-for="item in dataBranchlists" :key="item.BranchID" v-bind:value="{ BranchID: item.BranchID, BranchName: item.BranchName }" :selected="item.BranchID==5">
                              {{ item.BranchName }}
                            </option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm">
                    <!-- วันที่ใบสั่งตรวจ -->
                    <div class="input-group input-group-sm mb-1">
                      <span class="input-group-text" style="width:160px;">วันที่เอกสาร จาก-ถึง :</span>
                      <v-date-picker mode="date" v-model="dateFm" :masks="masks">
                          <template v-slot="{ inputValue, inputEvents }">
                              <input name="dateFm" ref="dateFm" style="width:120px;"
                              class="bg-white border px-2 py-1 rounded"
                              :value="inputValue"
                              v-on="inputEvents"
                              />
                          </template>
                      </v-date-picker>
                      <v-date-picker mode="date" v-model="dateTo" :masks="masks">
                          <template v-slot="{ inputValue, inputEvents }">
                              <input name="dateTo" ref="dateTo" style="width:120px;"
                              class="bg-white border px-2 py-1 rounded"
                              :value="inputValue"
                              v-on="inputEvents"
                              />
                          </template>
                      </v-date-picker>
                      <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="getData()">ดึงข้อมูล</button>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <RepSumTestsuit1View  :datalists="datalists" :key="countRefresh"
        :branchSelected="branchSelected"
        :dateFm="dateFm" :dateTo="dateTo" :statusSelectedText="statusSelectedText"></RepSumTestsuit1View>

    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import JsBarcode from 'jsbarcode/bin/JsBarcode'
import RepSumTestsuit1View from './RepSumTestsuit1View.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'RepLabStatus',
  components: {
    RepSumTestsuit1View
  },
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchSelected: null,
      branchID: 0,
      dateFm: new Date(),
      dateTo: new Date(),
      status0New: true,
      status1Lab: true,
      status2Res: true,
      status3App: true,

      countRefresh: 0,
      datalists: null,
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null,
      dataBranchItem: null // item สาขาที่เป็นค่าเริ่มต้น สาขาของ current user
    }
  },
  computed: {
    // a computed getter
    statusSelectedText: function () {
      // return ==>  'New/Lab/Resulted/AP'  ตาม checkbox ที่เลือก
      var result = ''
      if (this.status0New) {
        result = result + '/' + this.arrDocStatus[0]
      }
      if (this.status1Lab) {
        result = result + '/' + this.arrDocStatus[1]
      }
      if (this.status2Res) {
        result = result + '/' + this.arrDocStatus[2]
      }
      if (this.status3App) {
        result = result + '/' + this.arrDocStatus[3]
      }
      if (result.length > 0) {
        result = result.substr(1, result.length - 1)
      }
      return result
    }
  },
  created () {
    // Initial Value
    this.getBranchData()
  },
  mounted () {
    this.branchID = this.globalBranchID
  },
  methods: {
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // this.dataBranchlists = resp.data.response
          const result = []
          for (const item of resp.data.response) {
            var rowObj = { BranchID: item.BranchID, BranchName: item.BranchName }
            if (item.BranchID === this.globalBranchID) {
              this.dataBranchItem = rowObj
            }
            result.push(rowObj)
          }
          this.dataBranchlists = result
          this.$nextTick(() => {
            this.branchSelected = this.dataBranchItem
          })
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getData () {
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchSelected.BranchID // this.branchID
      var Status0 = -1 // 0-New
      var Status1 = -1 // 1-Lab
      var Status2 = -1 // 2-Resulted
      var Status3 = -1 // 3-Approve
      if (this.status0New) {
        Status0 = 0 // 0-New
      }
      if (this.status1Lab) {
        Status1 = 1 // 1-Lab
      }
      if (this.status2Res) {
        Status2 = 2 // 2-Resulted
      }
      if (this.status3App) {
        Status3 = 3 // 3-Approve
      }
      MyApiClient.get('getdata/repsumtestsuit_where.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID + '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
        '&Status0=' + Status0 + '&Status1=' + Status1 + '&Status2=' + Status2 + '&Status3=' + Status3)
      // MyApiClient.get('getdata/tests_all.php')
        .then((resp) => {
          // console.log('After get by Cond..')
          // console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
            this.datalists = []
          }
          this.$nextTick(() => {
            $('#myRepTable').DataTable()
          })
          // setTimeout(function () { $('#myRepLabStatusTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
